import styled from "styled-components";

import InputError from "features/shared/styles/input/InputError.styled";
import Select from "./Select.styled";

export interface StyledPickerProps {
  focused: boolean;
  error: string | null;
}

const StyledPicker = styled.div<StyledPickerProps>`
  ${Select} {
    width: 100%;
  }

  ${InputError} {
    margin-top: 12px;
  }
`;

export default StyledPicker;
